<div id="klarna-payments-{{paymentCategory.identifier}}"></div>
